import { useMutation, useQueryClient } from '@tanstack/react-query';
import useAuthenticatedFetch from './useAuthenticatedFetch';
import useSnackbar from './useSnackbar';

const useAuthenticatedMutation = (url: string, invalidateKey?: string[] | string, options = {}) => {
  const handleFetch = useAuthenticatedFetch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (req) => handleFetch(url, req),
    onSettled: () => queryClient.invalidateQueries({
      queryKey: invalidateKey ? Array.isArray(invalidateKey) ? invalidateKey : [invalidateKey] : [url]
    }),
    ...options
  });
};

export function usePutMutation(url: string, invalidateKey?: string[] | string) {
  const mutation = useAuthenticatedMutation(url, invalidateKey);
  const { showSnackbar } = useSnackbar();
  const onError = () => showSnackbar('An error occurred. If the problem persists please contact support.', 'error');

  return {
    ...mutation,
    mutate: (body: {}, options = {}) => {
      const variables: any = { body, method: 'PUT' };
      return mutation.mutate(variables, { onError, ...options });
    }
  };
}

export function usePostMutation(url: string, invalidateKey?: string[] | string) {
  const mutation = useAuthenticatedMutation(url, invalidateKey);
  const { showSnackbar } = useSnackbar();
  const onError = () => showSnackbar('An error occurred. If the problem persists please contact support.', 'error');

  return {
    ...mutation,
    mutate: (body: {}, options = {}) => {
      const variables: any = { body, method: 'POST' };
      return mutation.mutate(variables, { onError, ...options });
    }
  };
}

export function useDeleteMutation(url: string, invalidateKey?: string[] | string) {
  const mutation = useAuthenticatedMutation(url, invalidateKey);
  const { showSnackbar } = useSnackbar();
  const onError = () => showSnackbar('An error occurred. If the problem persists please contact support.', 'error');

  return {
    ...mutation,
    mutate: (options = {}) => {
      const variables: any = { method: 'DELETE' };
      return mutation.mutate(variables, { onError, ...options });
    }
  };
}